/**
 * État réactif Web Push : permission OS + subscription côté Worker.
 *
 * Hydraté au boot par push.ts::loadInitialPushState().
 */

interface PushState {
  /** Permission notification OS (granted = OK, denied = blocked, default = jamais demandé). */
  permission: NotificationPermission | "unknown";
  /** True si une PushSubscription existe ET est registrée côté Worker. */
  subscribed: boolean;
  /** Endpoint actuel pour debug (host = push service Apple/Google/Mozilla). */
  endpointHost: string | null;
  /** True pendant subscribe/unsubscribe — désactive le bouton. */
  busy: boolean;
}

export const pushState = $state<PushState>({
  permission: "unknown",
  subscribed: false,
  endpointHost: null,
  busy: false,
});
